module.exports = __webpack_public_path__ + "img/logo_nl.df065d9c.png";